import { render } from "./RxDrugs.vue?vue&type=template&id=7c5e0fcd&scoped=true"
import script from "./RxDrugs.vue?vue&type=script&lang=js"
export * from "./RxDrugs.vue?vue&type=script&lang=js"

import "./RxDrugs.vue?vue&type=style&index=0&id=7c5e0fcd&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c5e0fcd"]])

export default __exports__